module.exports = __webpack_public_path__ + "static/media/multipleOptions.25d80f3e.svg";